export default __webpack_public_path__ + "static/media/ic_arrow_top.4a34a8c9.svg";